import '../../assets/css/style1.css';
import { Link } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Socialicon from '../../pages/PrivacyPolicy/Socialicon';
import logoImage from '../../assets/images/logo.jpeg';

const Footer = () => {

  // =========================================
  // DYNAMIC SERVICES (auto-populated as services are published in the CMS)
  // =========================================

  const [footerServices, setFooterServices] = useState([]);

  useEffect(() => {
    api.get('/services')
      .then((res) => setFooterServices((res.data.data || []).slice(0, 6)))
      .catch(() => {}); // Non-critical - footer still renders without it
  }, []);

  // =========================================
  // NEWSLETTER
  // =========================================

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // =========================================
  // ENQUIRY STATES
  // =========================================

  const [showInquiry, setShowInquiry] = useState(false);

  const [submittingInquiry, setSubmittingInquiry] = useState(false);

  const [inquiryData, setInquiryData] = useState({
    name: '',
    email: '',
    phone_number: '',
    message: '',
  });

  // =========================================
  // NEWSLETTER SUBMIT
  // =========================================

  const onFinish = async (values) => {

    try {

      setLoading(true);

      const response = await api.post('/subscribe', values);

      if (response.data.success) {

        message.success('Thank you for subscribing!');

        form.resetFields();

      } else {

        message.error(response.data.message || 'Subscription failed');

      }

    } catch (error) {

      message.error(
        error.response?.data?.message ||
        'Subscription failed'
      );

    } finally {

      setLoading(false);

    }

  };

  // =========================================
  // ENQUIRY CHANGE
  // =========================================

  const handleInquiryChange = (e) => {

    setInquiryData({
      ...inquiryData,
      [e.target.name]: e.target.value,
    });

  };

  // =========================================
  // ENQUIRY SUBMIT
  // =========================================

  const handleInquirySubmit = async (e) => {

    e.preventDefault();

    try {

      setSubmittingInquiry(true);

      await api.post('/submit-enquiry', inquiryData);

      message.success('Enquiry submitted successfully');

      setInquiryData({
        name: '',
        email: '',
        phone_number: '',
        message: '',
      });

      setShowInquiry(false);

    } catch (error) {

      console.error(error);

      message.error(
        error.response?.data?.message ||
        'Failed to submit enquiry'
      );

    } finally {

      setSubmittingInquiry(false);

    }

  };

  return (
    <>

      <footer className="footer5 footer--bw">

        <div className="footer__big">

          <div className="container">

            <div className="row">

              {/* =========================================
                  LOGO + ABOUT
              ========================================= */}

              <div className="col-lg-3 col-md-6 col-sm-6">

                <div className="widget text_widget">

                  <a className="navbar-brand order-sm-1 order-1" href="/">
                    <img
                      src={logoImage}
                      style={{ height: '86px' }}
                      alt="Logo"
                    />
                  </a>

                  <p>
                   BusinessMate & Workflow Pvt. Ltd. is a one-stop business ecosystem platform connecting entrepreneurs with partners, talent, professional services, and business opportunities.
                  </p>

                </div>

              </div>

              {/* =========================================
                  QUICK LINKS
              ========================================= */}

              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-lg-center">

                <div className="widget widget--links">

                  <h4 className="widget__title">Quick Links </h4>

                  <ul className="links">

                    <li>
                      <Link className="nav-link" to="/">Home</Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/about">About us</Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/plan">Plan</Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/video">Video</Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/blog">Blog</Link>
                    </li>

                

                    <li>
                      <Link className="nav-link" to="/contact">Contact</Link>
                    </li>

                  </ul>

                </div>

              </div>

              {/* =========================================
                  MORE LINKS
              ========================================= */}

              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-lg-center">

                <div className="widget widget--links">

                  <h4 className="widget__title">More Links</h4>

                  <ul className="links">

                    <li>
                      <Link className="nav-link" to="/privacypolicy">
                        Privacy Policy
                      </Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/teammember">
                        Our Team
                      </Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/termscondition">
                        Terms and Condition
                      </Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/refundpolicy">
                        Refund Policy
                      </Link>
                    </li>

                    <li>
                      <Link className="nav-link" to="/faq">
                        FAQ
                      </Link>
                    </li>

                  </ul>

                </div>

              </div>

              {/* =========================================
                  NEWSLETTER
              ========================================= */}

              <div className="col-lg-3 col-md-6 col-sm-6">

                <div className="widget subcribe--widget">

                  <h4 className="widget__title">
                    Newsletter
                  </h4>

                  <p>
                    Subscribe to get updates and latest information.
                  </p>

             

                    <div>

<Form
  form={form}
  onFinish={onFinish}
  className="subscribe-form-two"
  layout="vertical"
>
  <Form.Item
    name="email"
    rules={[
      {
        required: true,
        message: 'Enter email!'
      },
      {
        type: 'email',
        message: 'Enter a valid email!'
      }
    ]}
    style={{ marginBottom: '15px' }}
  >
    <Input
      type="email"
      placeholder="Enter email"
      className="form-control"
      style={{
        width: '100%',
        height: '45px',
        padding: '10px 15px'
      }}
    />
  </Form.Item>

  <Button
    htmlType="submit"
    type="primary"
    loading={loading}
    style={{
      width: '100%',
      height: '45px',
      padding: '0 18px'
    }}
  >
    Subscribe Now
  </Button>
</Form>

</div>

                  <div className="widget__social">

                    <div className="social">
                      <Socialicon />
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

        {/* =========================================
            COPYRIGHT
        ========================================= */}

        <div className="footer__small text-center">

          <p>
            ©2026 BusinessMateWorkflow™.
            All rights reserved.
          </p>

        </div>

        {/* =========================================
            WHATSAPP FLOATING BUTTON
        ========================================= */}

        <a
          href="https://wa.me/919319332918"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-floating-btn"
        >

          <img
            src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
            alt="WhatsApp"
          />

        </a>

        {/* =========================================
            ENQUIRY FLOATING SYSTEM
        ========================================= */}

        <div className="floating-enquiry-wrapper">

          {/* OPEN BUTTON */}

          {!showInquiry && (

            <button
              className="enquiry-toggle-btn"
              onClick={() => setShowInquiry(true)}
            >

              <span>💬</span> Enquire Now

            </button>

          )}

          {/* ENQUIRY BOX */}

          {showInquiry && (

            <div className="enquiry-chat-box">

              {/* HEADER */}

              <div className="enquiry-header">

                <div>

                  <h4>Quick Enquiry</h4>

                  <p>
                    We usually reply instantly
                  </p>

                </div>

                <button
                  className="close-chat-btn"
                  onClick={() => setShowInquiry(false)}
                >
                  ✕
                </button>

              </div>

              {/* BODY */}

              <div className="enquiry-body">

                <form onSubmit={handleInquirySubmit}>

                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={inquiryData.name}
                    onChange={handleInquiryChange}
                    required
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={inquiryData.email}
                    onChange={handleInquiryChange}
                    required
                  />

                  <input
                    type="text"
                    name="phone_number"
                    placeholder="Phone Number"
                    value={inquiryData.phone_number}
                    onChange={handleInquiryChange}
                    required
                  />

                  <textarea
                    name="message"
                    rows="4"
                    placeholder="Write your enquiry..."
                    value={inquiryData.message}
                    onChange={handleInquiryChange}
                    required
                  />

                  <button
                    type="submit"
                    className="submit-enquiry-btn"
                    disabled={submittingInquiry}
                  >

                    {
                      submittingInquiry
                        ? 'Submitting...'
                        : 'Submit Enquiry'
                    }

                  </button>

                </form>

              </div>

            </div>

          )}

        </div>

      </footer>

      {/* =========================================
          GO TO TOP
      ========================================= */}

      <div className="go_top">
        <span className="la la-angle-up"></span>
      </div>

    </>
  );
};

export default Footer;